import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type PopoverErrorProps = {
  children: ReactNode;
  className?: string;
  show: boolean;
};

export default function PopoverError({ className, children, show }: PopoverErrorProps) {
  if (!show) return null;
  return (
    <div
      className={twMerge('relative rounded-[8px] bg-root-tomato-red-light-2 p-[10px] text-critical-txt', className)}
      role="alert">
      <div
        className="absolute left-1/2 top-[-6px] h-0 w-0 -translate-x-1/2 border-solid border-b-[6px] border-b-root-tomato-red-light-2 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent"
        aria-hidden
      />
      <div className="enki-body-xs-medium">{children}</div>
    </div>
  );
}
